import { Model } from '@descomplica/dex-models';
import { ListModel } from './ListModel';

export interface WeekInfo {
  id: number;
  studyPlanningId: number;
  position: number;
  startDate: string;
  endDate: string;
  isAnticipated?: boolean;
}

export class WeekModel extends Model {
  id: number;

  studyPlanningId: number;

  position: number;

  isAnticipated: boolean;

  startDate: Date;

  endDate: Date;

  constructor(week: WeekInfo, getters: any) {
    super(getters);

    this.id = week.id;
    this.studyPlanningId = week.studyPlanningId;
    this.position = week.position;
    this.isAnticipated = week.isAnticipated ?? false;
    this.startDate = new Date(week.startDate);
    this.endDate = new Date(week.endDate);
  }

  get listsAndOverdueLists(): ListModel[] | null {
    if (!this.getters || !this.getters.studyPlanningWeekLists || this.isAnticipated) {
      return null;
    }

    return this.getters.studyPlanningWeekLists;
  }

  get anticipatedLists(): ListModel[] | null {
    if (!this.isAnticipated) return null;

    return this.getters.studyPlanningAnticipatedWeekListsByWeekId(this.id);
  }
}
